import React, { useEffect, useState } from "react";
import { Alert, Button, Input, message, Modal } from "antd";
import { useAtom } from "jotai";
import { SolicitudAusenciaService } from "services";
import { ApiResponse } from "enum";
import produce from "immer";
import {
	solicitudAusenciaSeleccionadaAtom,
	solicitudesAusenciaPendientesAprobarAtom,
	visibleModalRechazarSolicitudAusenciaAtom,
} from "../../SolicitudesPendientesAprobarStore";

const ModalRechazarSolicitudAusencia = () => {
	const [, setSolicitudesPendientesAprobar] = useAtom(solicitudesAusenciaPendientesAprobarAtom);
	const [solicitudAusenciaSeleccionada] = useAtom(solicitudAusenciaSeleccionadaAtom);
	const [visibleModal, setVisibleModal] = useAtom(visibleModalRechazarSolicitudAusenciaAtom);
	const [loading, setLoading] = useState(false);
	const [claveIngresada, setClaveIngresada] = useState("");
	const [motivo, setMotivo] = useState("");
	const [mensajeError, setMensajeError] = useState("");

	useEffect(() => {
		if (visibleModal) {
			setMotivo("");
			setClaveIngresada("");
			setMensajeError("");
		}
	}, [visibleModal]);

	const onClickBtnAprobar = async () => {
		if (claveIngresada === "") {
			setMensajeError("Ingrese la clave");
			return;
		}

		if (motivo === "") {
			setMensajeError("Ingrese un motivo");
			return;
		}

		setLoading(true);
		const response = await SolicitudAusenciaService.rechazarPorJefeInmediato({
			solicitudAusenciaId: solicitudAusenciaSeleccionada.id,
			clave: claveIngresada,
			motivo: motivo,
		});
		if (response.estado === ApiResponse.EXITO) {
			message.success("Se ha rechazado la solicitud correctamente.");
			setVisibleModal(false);
			setSolicitudesPendientesAprobar(
				produce((draft) => {
					const index = draft.findIndex((solicitud) => solicitud.id === solicitudAusenciaSeleccionada.id);
					draft.splice(index, 1);
				})
			);
		} else {
			setMensajeError(response.mensaje);
		}
		setLoading(false);
	};
	const onClickBtnCancelar = () => {
		setVisibleModal(false);
	};
	return (
		<Modal
			title={
				<div>
					Rechazar Solicitud de: <b>{solicitudAusenciaSeleccionada?.colaborador.nombreCompleto}</b>
				</div>
			}
			visible={visibleModal}
			closable={false}
			width={400}
			destroyOnClose={true}
			footer={[
				<Button key="cancelar" disabled={loading} onClick={onClickBtnCancelar} style={{ padding: "0px 30px" }}>
					Cancelar
				</Button>,
				<Button
					key="aprobar"
					type="primary"
					loading={loading}
					onClick={onClickBtnAprobar}
					style={{ padding: "0px 30px" }}
				>
					Rechazar
				</Button>,
			]}
			centered
		>
			{mensajeError && (
				<Alert
					message={mensajeError}
					onClose={() => setMensajeError(undefined)}
					style={{ marginBottom: "4px" }}
					type="error"
					showIcon
					closable
				/>
			)}
			<span style={{ display: "block", marginBottom: "4px" }}>Ingresa tu clave</span>
			<Input.Password
				value={claveIngresada}
				onChange={(e) => {
					setClaveIngresada(e.target.value);
					setMensajeError(undefined);
				}}
				placeholder={"Clave"}
			/>

			<span style={{ display: "block", marginTop: "12px", marginBottom: "4px" }}>Motivo</span>
			<Input
				value={motivo}
				onChange={(e) => {
					setMotivo(e.target.value);
					setMensajeError(undefined);
				}}
				placeholder={"Ingresa un motivo"}
			/>
		</Modal>
	);
};

export default ModalRechazarSolicitudAusencia;
